import { PopoverArrow, PopoverContent } from '@/components/ui/popover';
import { useTranslation } from 'react-i18next';

export default function ScreenshotHintPopoverContent({ onDismiss }: { onDismiss: () => void }) {
  const { t } = useTranslation();

  return (
    <PopoverContent side="left" className="hidden md:block w-80 p-4 rounded-xl text-[14px] leading-[20px]">
      <img
        src="/images/edit-screenshot.jpg"
        alt={t('feedback.screenshotExampleAlt')}
        className="w-full rounded border"
        loading="lazy"
        aria-hidden="true"
      />

      <div className="text-sm font-semibold text-gray-900 mt-3">{t('feedback.screenshotHintTitle')}</div>

      <div className="text-sm text-gray-600 mt-1">{t('feedback.screenshotHintDescription')}</div>

      <div className="mt-2 flex justify-end">
        <button
          onClick={onDismiss}
          className="text-sm font-medium text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50 rounded py-2 px-4 transition-colors"
        >
          {t('feedback.screenshotHintOk')}
        </button>
      </div>

      <PopoverArrow className="w-6 h-4" />
    </PopoverContent>
  );
}
